export const DomainNamespace_AIPrompt = 'ai-prompt';
export const PermissionKey_AIPromptView = 'permission-key--ai-prompt-view';
export const PermissionKey_AIPromptEdit = 'permission-key--ai-prompt-edit';
//# sourceMappingURL=consts.js.map